const inviteConstants = {
    VALIDATE_REQUEST: 'VALIDATE_INVITE_REQUEST',
    VALIDATE_SUCCESS: 'VALIDATE_INVITE_SUCCESS',
    VALIDATE_FAILURE: 'VALIDATE_INVITE_FAILURE',

    INVITE_REQUEST: 'INVITE_REQUEST',
    INVITE_SUCCESS: 'INVITE_SUCCESS',
    INVITE_FAILURE: 'INVITE_FAILURE'
}
export { inviteConstants };